/**
 * Cube Component (SVG)
 *
 * Renders a 3D cube using SVG isometric projection via Cube2D.
 */

import React from 'react';
import { Cube2D } from './Cube2D';

interface CubeProps {
  side?: number;
  unit?: string;
  color?: string;
  strokeColor?: string;
}

export const Cube: React.FC<CubeProps> = ({
  side = 4,
  unit = 'cm',
  color = '#f3e5f5',
  strokeColor = '#9c27b0'
}) => {
  return <Cube2D side={side} unit={unit} color={color} strokeColor={strokeColor ?? color} />;
};

export default Cube;
